import api from '@/utils/api';
import {
    CUSTOMER_SERVICES_GET_LIST,
    CUSTOMER_SERVICES_GET_SPECIFIC,
    CUSTOMER_SERVICES_UPDATE_SPECIFIC,
    CUSTOMER_SERVICES_CREATE_NEW,
    CUSTOMER_SERVICES_REMOVE,
    CUSTOMER_SERVICES_GET_STATISTICAL,
    CUSTOMER_SERVICES,
    CUSTOMER_SERVICES_EXPORT_EXCEL,
    CUSTOMER_SERVICES_CONVERT_TO_SERVICE
} from './types';
import { NotificationManager } from 'react-notifications';

const notifyCommissionProcessing = data => {
    const results = [data?.commission_processing]
        .concat(data?.conversion_commission_processing || [])
        .filter(Boolean);
    const pending = results.find(result => ['PENDING', 'WAITING', 'FAILED_RETRY'].includes(result.status));
    if (pending) {
        NotificationManager.warning(pending.message || 'Giao dịch đã ghi nhận; hoa hồng đang chờ hệ thống xử lý lại.');
    }
};

export const getListServices = (filter) => dispatch => {
    return new Promise((resolve, reject) => {
        return api.get('/customer-services', { params: filter }).then(res => {
            dispatch({ type: CUSTOMER_SERVICES_GET_LIST, payload: res.data.data });
            resolve(res.data);
        }).catch(err => {
            NotificationManager.error(err?.response?.data?.msg || 'Không thể tải danh sách dịch vụ khách hàng.');
            reject(err);
        })
    })
}

export const getSpecificService = (id) => dispatch => {
    return new Promise((resolve, reject) => {
        return api.get(`/customer-services/${id}`).then(res => {
            dispatch({ type: CUSTOMER_SERVICES_GET_SPECIFIC, payload: res.data.data });
            resolve(res.data.data);
        }).catch(err => {
            NotificationManager.error(err?.response?.data?.msg || 'Không thể tải chi tiết dịch vụ khách hàng.');
            reject(err);
        })
    })
}

export const getCustomerServices = (customer_id) => dispatch => {
    return new Promise((resolve, reject) => {
        return api.get(`/customer-services/customer/${customer_id}`).then(res => {
            dispatch({ type: CUSTOMER_SERVICES, payload: res.data });
            resolve(res.data.data);
        }).catch(err => {
            NotificationManager.error(err?.response?.data?.msg || 'Không thể tải dịch vụ của khách hàng.');
            reject(err);
        })
    })
}

export const createService = (data) => dispatch => {
    return new Promise((resolve, reject) => {
        return api.post('/customer-services', data).then(res => {
            dispatch({ type: CUSTOMER_SERVICES_CREATE_NEW, payload: res.data.data });
            NotificationManager.success("Thêm mới bản ghi thành công!");
            resolve(res.data.data);
        }).catch(err => {
            NotificationManager.error(err?.response?.data?.msg || 'Không thể tạo dịch vụ khách hàng. Vui lòng kiểm tra dữ liệu.');
            reject(err);
        })
    })
}

export const convertToService = (data) => dispatch => {
    return new Promise((resolve, reject) => {
        return api.post('/customer-services/convert-to-service', data).then(res => {
            dispatch({ type: CUSTOMER_SERVICES_CONVERT_TO_SERVICE, payload: res.data.data });
            NotificationManager.success(res.data.msg || "Chuyển đổi dịch vụ thành công!");
            notifyCommissionProcessing(res.data.data);
            resolve(res.data.data);
        }).catch(err => {
            NotificationManager.error(err?.response?.data?.msg || 'Không thể chuyển đổi dịch vụ. Không có dữ liệu nào được thay đổi.');
            reject(err);
        })
    })
}

export const updateService = (id, data) => dispatch => {
    return new Promise((resolve, reject) => {
        return api.put(`/customer-services/${id}`, data).then(res => {
            dispatch({ type: CUSTOMER_SERVICES_UPDATE_SPECIFIC, payload: res.data.data });
            const impact = res?.data?.data?.financial_adjustment?.impact_snapshot || {};
            const autoApplied = Number(impact.auto_applied_balance || 0);
            const uncovered = Number(impact.uncovered_increase || 0);
            if (autoApplied > 0) {
                NotificationManager.success(`Đã tự động dùng ${autoApplied.toLocaleString('vi-VN')}đ từ số dư; công nợ tăng thêm ${uncovered.toLocaleString('vi-VN')}đ.`);
            } else {
                NotificationManager.success("Cập nhật bản ghi thành công!");
            }
            // [LOCKED-PERIOD-SERVICE-UPDATE] Dịch vụ luôn được lưu trước; nếu kỳ hoa hồng đã khóa
            // thì hiển thị trạng thái xử lý hậu kỳ giống luồng phiếu thu, không biến nó thành lỗi cập nhật dịch vụ.
            notifyCommissionProcessing(res.data.data);
            resolve(res.data);
        }).catch(err => {
            const errorMessage = err?.response?.data?.msg || '';
            const isAllocationConflict = err?.response?.status === 409
                && errorMessage.indexOf('Không thể tự cập nhật phân bổ cho role') === 0;
            if (!isAllocationConflict) {
                NotificationManager.error(err?.response?.data?.msg || 'Không thể cập nhật dịch vụ khách hàng.');
            }
            reject(err);
        })
    })
}

export const removeService = (ids, reason) => dispatch => {
    return new Promise((resolve, reject) => {
        return api.delete(`/customer-services`, { data: { ids: ids, reason } }).then(res => {
            dispatch({ type: CUSTOMER_SERVICES_REMOVE, payload: ids });
            NotificationManager.success(res.data.msg || "Đã hủy dịch vụ và cập nhật dữ liệu liên quan.");
            resolve(res.data);
        }).catch(err => {
            NotificationManager.error(err?.response?.data?.msg || 'Không thể hủy dịch vụ. Không có dữ liệu nào được thay đổi.');
            reject(err);
        })
    })
}

export const getStatistical = (filter) => (dispatch) => {
    return new Promise((resolve, reject) => {
        return api.get('/customer-services/statistical/total', { params: filter }).then(res => {
            //console.log(res.data)
            dispatch({
                type: CUSTOMER_SERVICES_GET_STATISTICAL,
                payload: res.data.data
            });
            resolve(res.data);
        }).catch(err => {
            NotificationManager.error(err?.response?.data?.msg || 'Không thể tải số liệu tổng hợp dịch vụ.');
            reject(err);
        });
    });
}

export const exportExcel = (filter) => dispatch => {
    return new Promise((resolve, reject) => {
        return api.post(`/customer-services/export`, filter).then(res => {
            dispatch({ type: CUSTOMER_SERVICES_EXPORT_EXCEL, payload: res.data.data });
            resolve(res.data.data);
        }).catch(err => {
            NotificationManager.error(err?.response?.data?.msg || 'Không thể xuất danh sách dịch vụ khách hàng.');
            reject(err);
        });
    })
}

export const getCustomerServiceCommissionSetup = id => dispatch => {
    return api.get(`/customer-services/${id}/commission-setup`).then(res => res.data.data).catch(err => {
        NotificationManager.error(err?.response?.data?.msg || 'Không thể tải thiết lập hoa hồng của dịch vụ.');
        throw err;
    });
}

export const getCustomerServiceConditionValues = id => dispatch => {
    return api.get(`/customer-services/${id}/condition-values`).then(res => res.data.data || []).catch(err => {
        NotificationManager.error(err?.response?.data?.msg || 'Không thể tải điều kiện tính hoa hồng của dịch vụ.');
        throw err;
    });
}

export const updateCustomerServiceCommissionSetup = (id, data) => dispatch => {
    return api.put(`/customer-services/${id}/commission-setup`, data).then(res => {
        NotificationManager.success(res.data.msg || 'Đã cập nhật thiết lập hoa hồng.');
        return res.data.data;
    }).catch(err => {
        NotificationManager.error(err?.response?.data?.msg || 'Không thể cập nhật thiết lập hoa hồng.');
        throw err;
    });
}

export const reportCustomerServiceStaffFailure = (customerServiceId, data) => dispatch => {
    return api.post(`/customer-services/${customerServiceId}/staff-failures`, data).then(res => {
        NotificationManager.success(res.data.msg || 'Đã ghi nhận ca không thành công và gửi yêu cầu điều chỉnh hoa hồng.');
        return res.data.data;
    }).catch(err => {
        NotificationManager.error(err?.response?.data?.msg || 'Không thể báo cáo ca không thành công.');
        throw err;
    });
}

export const getCustomerServiceFinancialHistory = id => dispatch => {
    return Promise.all([
        api.get(`/customer-finance/customer-services/${id}/adjustments`),
        api.get(`/customer-services/${id}/selected-at-adjustments`),
        api.get(`/customer-services/${id}/commission-deltas`),
    ]).then(([financialResponse, selectedAtResponse, commissionDeltaResponse]) => ({
        financialAdjustments: financialResponse.data.data || [],
        selectedAtAdjustments: selectedAtResponse.data.data || [],
        commissionAdjustments: commissionDeltaResponse.data.data || [],
    })).catch(err => {
        NotificationManager.error(err?.response?.data?.msg || 'Không thể tải lịch sử thay đổi tài chính của dịch vụ.');
        throw err;
    });
}
